var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VContainer',{attrs:{"fluid":""}},[_c('VRow',[_c('CtaGainAccess')],1),_c('VRow',{staticClass:"atomic-lock"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }